import { Link, LinkProps } from '@online-webinar/router';

export const MenuItemOption = ({ children, ...props }: LinkProps) => (
    <Link {...props} className="block px-4 py-2 text-sm hover:bg-primary hover:text-on-primary text-left w-full">
        {children}
    </Link>
);
